module.exports = __webpack_public_path__ + "static/media/insights-img-3.d7ec6424.png";